import { Main } from "../../components";

export const Orcamentos = () => {
  return (
    <Main>
      <section id="services" className="services">
        <div className="container" data-aos="fade-up">
          <div className="section-title">
            <h2>Orçamentos</h2>
          </div>
        </div>
      </section>
      <section id="budget-management-report" className="section-bg">
        <section id="services" className="services">
          <div className="container" data-aos="fade-up">
            <div id="index-composition" className="services">
              <div className="container padding-top-bottom" data-aos="fade-up">
                <div className="row">
                  <div
                    className="col-xl-3 col-md-6 d-flex align-items-stretch"
                    data-aos="zoom-in"
                    data-aos-delay="100"
                  >
                    <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                      <div className="icon">
                        <img
                          className="pdf-icon"
                          src="/assets/img/pdf-icon.png"
                          alt=""
                        />
                      </div>
                      <h4>
                        <a
                          target="_blank"
                          href="https://drive.google.com/file/d/1IFWiSONlS9wDz4xEB2NvG_tNpiHyknKR/view?usp=drive_link"
                          rel="noreferrer"
                        >
                          Orçamento de Hospedagem 1
                        </a>
                      </h4>
                    </div>
                  </div>
                  <div
                    className="col-xl-3 col-md-6 d-flex align-items-stretch"
                    data-aos="zoom-in"
                    data-aos-delay="100"
                  >
                    <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                      <div className="icon">
                        <img
                          className="pdf-icon"
                          src="/assets/img/pdf-icon.png"
                          alt=""
                        />
                      </div>
                      <h4>
                        <a
                          target="_blank"
                          href="https://drive.google.com/file/d/1IG0pkcGPn7mD7n8FR20BUInDCyHeP3FW"
                          rel="noreferrer"
                        >
                          Orçamento de Hospedagem 2
                        </a>
                      </h4>
                    </div>
                  </div>
                  <div
                    className="col-xl-3 col-md-6 d-flex align-items-stretch"
                    data-aos="zoom-in"
                    data-aos-delay="100"
                  >
                    <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                      <div className="icon">
                        <img
                          className="pdf-icon"
                          src="/assets/img/pdf-icon.png"
                          alt=""
                        />
                      </div>
                      <h4>
                        <a
                          target="_blank"
                          href="https://drive.google.com/file/d/1IBPDTucL8SfDBCjwXXRatr_Igv8yBjiN"
                          rel="noreferrer"
                        >
                          Orçamento de Hospedagem 3
                        </a>
                      </h4>
                    </div>
                  </div>
                  <div
                    className="col-xl-3 col-md-6 d-flex align-items-stretch"
                    data-aos="zoom-in"
                    data-aos-delay="100"
                  >
                    <div className="icon-box pdf-icon-box d-flex align-items-center flex-column">
                      <div className="icon">
                        <img
                          className="pdf-icon"
                          src="/assets/img/pdf-icon.png"
                          alt=""
                        />
                      </div>
                      <h4>
                        <a
                          target="_blank"
                          href="https://drive.google.com/file/d/1ocmgxEZHHIVVy44TWmGIkw28vNCYmK9O"
                          rel="noreferrer"
                        >
                          Orçamento Uniformes
                        </a>
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </section>
    </Main>
  );
};
